// 3rd party
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http/';
import { CommonModule } from '@angular/common/';
import { RouterModule } from '@angular/router/';
import { TranslateModule } from '@ngx-translate/core';

// components
import { ReportListComponent } from 'app/reports/report-list/report-list.component';
import { ReportFormDialogComponent } from 'app/reports/report-form-dialog/report-form-dialog';

// modules
import { MaterialModule } from 'app/shared/material/material.module';
import { ComponentsModule } from 'app/shared/components/components.module';

// services
import { ReportService } from 'app/reports/shared/report.service';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    MaterialModule,
    RouterModule,
    TranslateModule,
    ComponentsModule,
  ],
  exports: [
    ReportFormDialogComponent,
    ReportListComponent
  ],
  declarations: [
    ReportFormDialogComponent,
    ReportListComponent
  ],
  providers: [
    ReportService
  ],
  entryComponents: [
    ReportFormDialogComponent
  ]
})
export class ReportsModule { }



// WEBPACK FOOTER //
// ./src/app/reports/reports.module.ts